import basex from 'base-x'

// Used for pairing codes and peyote IDs. Alphanumeric-only (no +/=) so encoded strings are
// triple-click selectable in terminals and editors.
export const base62 = basex('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz')
